import type { WidgetHost } from "./host";

let current: WidgetHost | undefined;

export const setWidgetHost = (host: WidgetHost): void => {
  current = host;
};

export const widgetHost = (): WidgetHost | undefined => current;
